<template>
  <div class="Contact" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                  <b-breadcrumb-item>
                    <router-link to="/AS_AllDocuments">
                      নথি
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>চক্ৰ অনুসৰি চাট্‌-দাউন জাননী</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw;">
            <div id="circle">

             <p class="content">
                <b-table  :items="CircleList" :fields="Circlefields">
                  <template v-slot:cell(name)="data">
                   <span v-html="data.value"></span>
                  </template>
                </b-table>
             </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
</template>

<script>
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SN',
  components: {
        'HeaderFixed' : HeaderFixed,
        'HeaderMobile' : HeaderMobile
    },

  data() {
      return {

        Circlefields: [
          { key: 'name', label: 'চক্ৰ অনুসৰি চাট্‌-দাউন জাননী',thStyle: {color:'#1976d2  ',fontSize:'1.5rem'} }
        ],
        CircleList1 :[
          {"name":"GEC-I"},
          {"name":"GEC-II"},
          {"name":"Rangia"},
          {"name":"Mangaldoi"},
          {"name":"Bongaigaon"},
          {"name":"Kokrajhar"},
          {"name":"Barpeta"},
          {"name":"Nagaon"},
          {"name":"Morigaon"},
          {"name":"KANCH"},
          {"name":"Tezpur"},
          {"name":"North Lakhimpur"},
          {"name":"Cachar"},
          {"name":"Badarpur"},
          {"name":"Jorhat"},
          {"name":"Golaghat"},
          {"name":"Sivasagar"},
          {"name":"Dibrugarh"},
          {"name":"Tinsukia"}

        ]
      }
  },
  computed:
  {
    CircleList()
    {
    
      var temp=[];
      var i=2
      this.CircleList1.forEach(element => {
        var obj = {
        "name" : "<a href='/website/AS_ShutdownNotices?circle=" + i + "'>" + element.name  + "</a>"
        }
        temp.push(obj);
        i++;
      })
      return temp;
    }
  },


}
</script>

<style scoped="true">
  li{
    padding:0;
  }
  body{
    overflow-y:hidden;
  }
  table{
    text-align: left;
  }
  .headerF{
    display: block;
  }
  .headerM{
    display: none;
  }
  @media (max-width: 768px) {
      .headerF{
        display: none;
      }
      .headerM{
        display: block;
      }
    }
</style>
